module.exports = __webpack_public_path__ + "static/media/room2_2.5cc2ce42.JPG";